import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { AdministracionService } from 'src/app/administracion/administracion.service';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { ContactosService } from 'src/app/contactos/contactos.service';
import { FAZILService, User, UserService } from 'src/app/core';
import { ResultData, UIService } from 'src/app/core/services/ui.service';
import { EmissionPoint } from 'src/app/modelo/EmissionPoint';
import { Establishment } from 'src/app/modelo/Establishment';
import { Invoice } from 'src/app/modelo/Invoice';
import { InvoiceDetail } from 'src/app/modelo/InvoiceDetail';
import { Product } from 'src/app/modelo/Product';
import { Subject } from 'src/app/modelo/Subject';
import { SubjectCustomer } from 'src/app/modelo/SubjectCustomer';
import { ComprobantesService } from 'src/app/services/comprobantes.service';
import { DataService } from 'src/app/services/data.service';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { precisionRound, toLowerCase, validateDni, validateDNIPattern, validateEmail, validateRUC } from 'src/app/shared/helpers';
import { environment } from 'src/environments/environment';
import { FacturasService } from '../facturas.service';
import { PaymentMethod } from 'src/app/modelo/PaymentMethod';
import { EstablecimientosService } from 'src/app/perfil/establecimientos/establecimientos.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { COMMA, ENTER, SPACE, TAB } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { VeronicaApiSubErrorData } from 'src/app/modelo/VeronicaAPIErrorData';
import { PageOptions } from 'src/app/core/models/pagination';
import { SubjectCustomerOutput } from 'src/app/core/models/contacto.model';
import { ProductoOutput } from 'src/app/core/models/producto.model';

@Component({
    selector: 'app-factura-popup',
    templateUrl: './factura-popup.component.html',
    styleUrls: ['./factura-popup.component.scss']
})
export class FacturaPopupComponent implements OnInit, OnChanges {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    //Variables con objeto de edición
    currentUser: User;
    factura: Invoice = new Invoice();
    @Input() details: InvoiceDetail[] = [];

    //Variables para contactos
    mostrarPopupSubjectCustomers: boolean = false;
    subjectCustomer: SubjectCustomer = new SubjectCustomer();
    
    //Objeto de busqueda para asociar a la factura
    subject: Subject = new Subject();
    subjectCode: string;
    subjectCodeValid: boolean = false;
    emailValid: boolean = false;
    searching = false;

    //Variables para productos
    products: Product[] = [];
    productsFiltered: Product[] = [];
    productTypes: any[] = [];
    productType: any;
    product: Product = new Product();
    productSelected: Product = new Product();
    mostrarPopupProducts: boolean = false;
    mostrarEditorProduct: boolean = false;
    ivaValor: number = this.appConfig.app.iva.factor / 100;
    iva12: boolean = true;

    //Variables para establecimientos
    establishments: Establishment[] = [];
    establishment: Establishment = new Establishment();
    emissionPointSelected: EmissionPoint = new EmissionPoint();

    //Variables auxiliares
    isUnitDetail: boolean = true;
    exitenProductosSeleccionados: boolean = false;

    cargandoDataInit: boolean = false;
    procesando: boolean = false;
    processFilter = false;
    verificando: boolean = false;
    verificandoData: ResultData;
    resultData: ResultData;
    resultDataButtons: any[] = [];
    mostrarResultData: boolean = false;
    ui: UIService;

    paymentMethods: PaymentMethod[] = [];
    selectedPaymentMethod: PaymentMethod;

    //Help Section
    safeSrc: SafeResourceUrl;
    display: boolean;
    pageDescription: string;

    //Campos adicionales
    camposAdicionales: any[] = [];

    //Chips destinatarios
    separatorKeysCodes: number[] = [ENTER, COMMA, SPACE, TAB];
    destinatarioCtrl = new FormControl('');
    filtered: Observable<string[]>;
    destinatarios: string[] = [];
    destinatariosAll: string[] = [];
    @ViewChild('destinatarioInput') destinatarioInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;
    
    pageOptions: PageOptions = { page: 0, pageSize: 10, filter: '' };
    
    private subscription: Subscription | undefined;
    
    seRealizoBusquedaEspecifica:boolean = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userService: UserService,
        private fazilService: FAZILService,
        private uiService: UIService,
        private dataService: DataService,
        private confirmationService: ConfirmationService,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private facturasService: FacturasService,
        private comprobantesService: ComprobantesService,
        private contactosService: ContactosService,
        private serviciosService: ServiciosService,
        private administracionService: AdministracionService,
        private establecimientosService: EstablecimientosService,
        private sanitizer: DomSanitizer,
    ) {
        this.ui = uiService;
        this.cargarDataConstructor();
        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl('https://www.facturafacilecuador.com/ayudas_docs/pdf/ayuda/ayuda_nueva_factura.pdf');
        this.pageDescription = 'En esta opción usted puede realizar la emisión de una nueva factura para un cliente.';
    }
    
    ngOnInit(): void {
        this.userService.currentUser.subscribe(userData => {
            this.currentUser = userData;
            if (this.currentUser && this.currentUser.uuid) {
                if (this.currentUser.assistant.complete) {
                    this.establishments = this.currentUser.organization.establecimientos;
                } else {
                    this.fazilService.irAInicio(); //Mostrar el asistente
                }
            }
        });
        this.userService.establishment.subscribe(
            (data) => {
                this.establishment = data;
            }
        );
        this.userService.emissionPoint.subscribe(
            (data) => {
                this.emissionPointSelected = data;
                this.cargarDataInit();
            }
        );
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        if (changes) {
            if (changes.details) {
                const { currentValue, previousValue } = changes.fields;
                if (currentValue && currentValue !== previousValue) {
                    this.actualizarDetalle();
                }
            }
        }
    }

    cargarDataConstructor() {
        this.cargandoDataInit = true;
        this.route.data.subscribe((data) => {
            if (data['factura']) {//Editar factura normal
                this.factura = data['factura'];
            } else if (data['facturaExtendido']) {//Es una factura extendida
                this.factura = data['facturaExtendido'];
            } 
        });
        
        this.breadcrumbService.setItems([
            { label: 'Factura', routerLink: ['facturas/factura'] }
        ]);

        this.productTypes = this.appConfig.properties.productTypes;
    }

    async cargarDataInit() {
        
        
        //Cargar paymentmethods
        this.paymentMethods = await this.comprobantesService.getPaymentMethodsData();

        //Cargar datos de la factura
        //Cargar customer
        if (this.factura && this.factura.subjectCustomer) {
            this.subjectCustomer = this.factura.subjectCustomer;
            this.factura.subjectCustomer = new SubjectCustomer();
        }

        //Cargar details
        if (this.factura && this.factura.details && this.factura.details.length > 0) {
            this.details = this.factura.details ? this.factura.details : [];
            this.productsFiltered = this.ui.getProductsByDetails(this.details, this.products);
            this.isUnitDetail = this.ui.checkInvoiceSimpleComplex(this.details);
            this.generarFacturaSimpleComplex();
        }

        //Cargar método de pago
        if (this.factura && this.factura.paymentMethod) {
            let method: PaymentMethod = this.paymentMethods.find((item) => item.code == this.factura.paymentMethod);
            this.selectedPaymentMethod = method ? method : new PaymentMethod();
        }

        //Cargar emissionPoint y establishment
        if (this.factura && this.factura.emissionPoint && this.factura.emissionPoint.id) {
            this.establishment = this.establishments.find((item) => item.id == this.factura.emissionPoint.establishmentId);
            this.emissionPointSelected = this.establishment.emissionPoints.find( (ep) => ep.name = this.factura.emissionPoint.name );
        }
            //Cargar emissionPoint si es nueva factura
        if (!this.factura || !this.factura.id) {
            //dummy
        }
        
        //Cargar las secuencias
        this.establishments.forEach( (estab) => {
            estab.emissionPoints.forEach ( async (ep) => {
                if (estab.name && ep.name){
                    const ptoEmi:EmissionPoint = await this.establecimientosService.getPuntoEmisionSecuenciasData(estab.name, ep.name, 'facturas');
                    ep.secuencias = ptoEmi.secuencias;
                }
            })
        });

        //Validar campos para reenvío POSTED
        if (this.factura && this.factura.internalStatus && this.factura.internalStatus == 'POSTED') {
            if (!this.formMainValid()) {
                this.ui.mostrarMensaje("warn", `${this.appConfig.ux.formIvalid}. No podrá emitir esta factura debido a que falta información importante no modificable. 
                Le recomendamos que realice una nueva factura.`);
            }
        }

        //Cargar campos adicionales de la organización
        this.camposAdicionales = []; //Encerar opciones.
        const campoAdicional = this.currentUser.organization.campoAdicional;
        const splits = campoAdicional && campoAdicional.length > 0 ? campoAdicional.split(",") : [];
        let index = 0;
        splits.forEach(campo => {
            let valor = null;
            let ayuda = null;
            let disabled:boolean = false;
            if ( toLowerCase(campo) === "correo" &&  this.factura!.subjectCustomer){
                valor = this.factura!.subjectCustomer!.customerEmail;
            } else if ( toLowerCase(campo) === "paciente" &&  this.factura!.subjectCustomer){
                valor = this.factura!.subjectCustomer!.customerFullName;
            } else if ( toLowerCase(campo) === "calificación artesanal nro"){
                valor = this.currentUser.organization.artesanoCalificadoNumero;
            } else if ( toLowerCase(campo) === "ruc proveedor"){
                valor = this.currentUser.rucProveedor;
                ayuda = "Resolución SRI: NAC-DGERCGC26-00000027";
                disabled = true;
            }
            this.camposAdicionales.push({ name: 'Campo' + index, type: 'text', value: valor, label: campo, ayuda: ayuda, disabled: disabled })
            index++;
            index++;
        });
        
        this.cargandoDataInit = false;
    }

    confirmarFacturar(event) {
        this.ui.limpiarMessages();
        if (this.currentUser.tieneCertificadoDigital) {
            //Ventana de confirmación
            let mensaje = this.appConfig.ux.confirmEnvioFacturaDesarrollo;
            if (this.currentUser.organization.ambientePro) {
                mensaje = this.appConfig.ux.confirmEnvioFacturaProduccion;
            }
            this.confirmationService.confirm({
                message: mensaje,
                accept: () => {
                    this.guardarFactura(event);
                },
            });
        } else {
            let header = "¡Suscríbase a " + this.appConfig.app.name + "!";
            let body = `Registre su certificado de firma electrónica llamando al ${environment.settings.app.contact.phone} o escribiendo a ${environment.settings.app.contact.email}.`;
            let type = "error";
            this.resultData = { header: header, body: body, type: type, subErrors: null };
            this.resultDataButtons = [];
            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
            this.mostrarResultData = true;
        }
    }

    formMainValid() {
        
        if (this.factura.internalStatus == 'CREATED' || this.factura.internalStatus == 'POSTED') {
            return true;
        }
        
        let dniValido = this.subjectCustomer.esExtranjero ? true : validateDni(this.subjectCustomer.customerCode);
        let valido: boolean = true;
        if (!this.subjectCustomer
            || !this.subjectCustomer.customerCode
            || !this.subjectCustomer.customerId
            || !dniValido ) {
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
            valido = false;
        } else if (!this.factura || !this.subjectCustomer || !this.details) {
            valido = false;
        } else if (this.factura && this.factura.direccion === '') {
            valido = false;
        } else if (this.factura && !this.selectedPaymentMethod) {
            valido = false;
        } else if (this.factura && (!this.destinatarios || this.destinatarios.length == 0)) {
            valido = false;
        } else if ( this.factura && (!this.details || this.details.length == 0) ) {
            this.ui.mostrarMensaje("error", `Se necesitan detalles para emitir la factura.`);
            valido = false;
        } else {
            this.establishment = this.establishments.find((item) => item.id == this.emissionPointSelected.establishmentId);
            if (!this.emissionPointSelected || !this.emissionPointSelected.id || !this.establishment || !this.establishment.id) {
                this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.emissionPointInvalid}`);
                valido = false;
            }
        }
        
        if ( this.factura && this.details && this.details.length > 0 ) {
            for (const item of this.details) {
                const nombre = item.product?.name ?? item.productName;
                if (nombre?.length > 256) { //SRI: En máximo es 300 caracteres en nombre de producto
                    valido = false;
                    this.ui.mostrarMensaje("error", `El nombre del producto ${nombre} sobrepasa el límite permitido por el SRI`);
                    break; // Detiene el bucle si el nombre supera los 300 caracteres
                }
                // Aquí va el resto de la lógica del bucle...
            }
        }
              
        return valido;
    }

    /**
    * Enviar factura al servidor
    */
    async guardarFactura(event) {
        this.ui.limpiarMessages();

        if (!this.formMainValid()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            this.procesando = true;
            this.subjectCustomer.customerPhoto = "";//remover foto
            //Establecer valores UX
            this.factura.details = this.details; //Los detalles de la factura
            this.factura.subjectCustomer = this.subjectCustomer;
            this.factura.emissionOn = this.factura.emissionOn ? this.factura.emissionOn : new Date();

            if ( this.factura && this.factura.internalStatus && this.factura.internalStatus == 'REJECTED' ) {
                this.factura.accionSRI = "enviar"; //Sólo enviar-autorizar-notificar al SRI
            } else if ( this.factura && this.factura.internalStatus && (this.factura.internalStatus == 'CREATED' || this.factura.internalStatus == 'POSTED') ) {
                this.factura.accionSRI = "autorizar"; //Sólo enviar-autorizar-notificar al SRI
            } else {
                this.factura.accionSRI = "emitir"; //Crear-enviar-autorizar-notificar
            }

            this.factura.enviarSRI = true;
            this.factura.ptoEmi = this.emissionPointSelected.name;
            this.factura.estab = this.establishment.name;
            this.factura.paymentMethod = this.selectedPaymentMethod.code; //Método de pago
            if (this.camposAdicionales && this.camposAdicionales.length > 0) {
                this.factura.camposAdicionales = this.camposAdicionales;
            }
            if (this.destinatarios && this.destinatarios.length > 0) {
                this.factura.destinatarios = this.destinatarios;
            }

            let header = "";
            let body = "";
            let type = "";
            let subErrors: VeronicaApiSubErrorData = null;
            //Guardar la factura en persistencia para luego recargar las facturas
            this.comprobantesService.enviarFactura(this.factura).subscribe(
                async (data) => {
                    const entidad = "Factura"
                    if (data['success'] && data['success'] == true && data['result']) {
                        let dataResult = data['result'];
                        let regresaComprobante: boolean = dataResult['comprobantes'] && Array.isArray(dataResult['comprobantes']) && dataResult['comprobantes'].length > 0;
                        const comprobantes = dataResult['comprobantes'];
                        if (regresaComprobante && dataResult['estado'] == 'APPLIED') {
                            //const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'];
                            header = this.appConfig.ux.messages.success + ` ${entidad} Autorizada por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else if (regresaComprobante && dataResult['estado'] != 'APPLIED') {
                            const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'] + ". " + comprobantes[0]['mensajes'][0]['informacionAdicional'];
                            header = this.appConfig.ux.messages.error + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}. El SRI respondió: ${mensajeSRI}`;
                            type = "error"
                        } else if (!regresaComprobante && dataResult['estado'] == 'APPLIED') {
                            header = this.appConfig.ux.messages.success + ` ${entidad} AUTORIZADA por el SRI`;
                            body = `La ${entidad} fue autorizada por SRI y se notificó al cliente.`;
                            type = "success"
                        } else {
                            const mensajeSRI = comprobantes[0]['mensajes'][0]['mensaje'] + ". " + comprobantes[0]['mensajes'][0]['informacionAdicional'];
                            header = this.appConfig.ux.messages.warn + ` ${entidad} devuelta por el SRI`;
                            body = `La ${entidad} fue recibida por SRI, pero no fue autorizada. Se marcó con el estado: ${dataResult['estado']}. El SRI respondió: ${mensajeSRI}`;
                            type = "warn"
                        }

                        //Mostar el resultado
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.resultDataButtons = [];
                        if (dataResult['estado'] == 'APPLIED') {
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonNuevoPedido);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonNuevaFactura);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonVerListado);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonVerPOS);
                        } else {
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        this.mostrarResultData = true;
                        //this.fazilService.irAInicio();
                    } else if (data['success'] && data['success'] == false && data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    } else if (data['errors']) {
                        this.resultDataButtons = [];
                        let dataError = data['errors'];
                        if (dataError['type'] == 'error-plan') {
                            header = dataError['message'].split('.')[0];
                            body = dataError['message'] ? dataError['message'].substring(dataError['message'].indexOf('.') + 1) : environment.settings.errorMsgs.error500;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonStatic);
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonSuscription);
                        } else {
                            header = this.appConfig.ux.messages.error;
                            body = dataError['message'] ? dataError['message'] : environment.settings.errorMsgs.error500_SRI;
                            this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                        }
                        type = dataError['type'] ? dataError['type'] : 'error';
                        this.resultData = { header: header, body: body, type: type, subErrors: null };
                        this.procesando = false;
                        this.mostrarResultData = true;
                    }
                },
                async (err) => {
                    header = this.appConfig.ux.messages.error;
                    type = this.appConfig.ux.messagesType.error;
                    if (err['errors']) {
                        body = (err && err["errors"]["message"]) ? err["errors"]["message"] : environment.settings.errorMsgs.error500;
                        subErrors = err["errors"]["payload"]["errors"]["payload"]["subErrors"];
                    } else {
                        body = (err && err["message"]) ? err["message"] : environment.settings.errorMsgs.error500;
                    }
                    this.resultData = { header: header, body: body, type: type, subErrors: subErrors };
                    this.resultDataButtons = [];
                    this.resultDataButtons.push(this.appConfig.ux.resultDataButtons.buttonOk);
                    this.procesando = false;
                    this.mostrarResultData = true;
                }
            );
        }
    }

    resetVariablesProducts(): void {
        this.ui.limpiarMessages();
        this.productType = null;
        this.mostrarEditorProduct = false;
        this.product = new Product();
    }

    nuevoServicio() {
        this.resetVariablesProducts();
        this.productType = (this.productTypes && this.productTypes.length) ? this.productTypes[0]['value'] : null;
        this.mostrarEditorProduct = true;
    }

    formProductCompleto() {
        return true;
    }

    async guardarServicio() {
        this.ui.limpiarMessages();
        if (!this.formProductCompleto()) {
            this.ui.mostrarMensaje("error", `${this.appConfig.ux.formIvalid}`);
        } else {
            //Establecer valores UX
            if (this.iva12) {
                this.product.taxType = '2'; //TABLA 17. IVA 
                this.product.taxFactor = this.appConfig.app.iva.factor;
            } else {
                this.product.taxType = '2';  //TABLA 17. IVA con porcentaje 0
                this.product.taxFactor = 0;
            }
            this.product.productType = this.productType;
            this.product.photo = null;
            //Guardar product en persistencia
            this.serviciosService.enviarProducto(this.product).subscribe(
                async (data) => {
                    this.productSelected = data;
                    this.productSelected.amount = 1;
                    this.agregarProductoSeleccionadoDeProductos();
                    this.mostrarEditorProduct = false;
                    this.mostrarPopupProducts = false;
                    this.ui.mostrarMensaje("success", `${this.product.name} ha sido registrado con éxito.`);
                },
                (err) => {
                    this.ui.mostrarError(err);
                }
            );
        }
    }

    /**
    ** Métodos de formulario
    **/
    resetSumadoresAll() {
        this.factura.price = 0.00;
        this.factura.subTotal = 0.00;
        this.resetSumadores();
    }

    resetSumadores() {
        //Encerar sumadores
        this.factura.descuento = 0.00;
        this.factura.propina = 0.00;
        this.factura.subTotalIva12 = 0.00;
        this.factura.subTotalIva0 = 0.00;
        this.factura.iva12Total = 0.00;
        this.factura.iva0Total = 0.00;
        this.factura.importeTotal = 0.00;
    }

    agregarProductoSeleccionado(p: Product) {
        let detail: InvoiceDetail = new InvoiceDetail();
        detail.productId = p.id;
        detail.product = p;
        detail.amount = detail.product.amount;
        detail.price = detail.product.price;
        this.details = this.ui.addDetailToInvoice(this.details, detail, false);
    }
  
    generarFacturaSimpleComplex() {
        if (this.details && this.details.length > 0) {
            if (this.isUnitDetail) {
                this.generarFacturaSimple(this.details[0]);
            } else {
                this.generarFacturaComplex();
            }
        } else {
            this.product = new Product();
            this.factura.price = 0;
        }
        this.resetSumadoresAll();
        this.calcularTotalesFactura();//En función de sus detalles
    }

    generarFacturaSimple(detail: InvoiceDetail) {
        this.product = detail.product; //Cargar el producto único
        this.exitenProductosSeleccionados = this.product != null;
    }

    generarFacturaComplex() {
        this.exitenProductosSeleccionados = false;
        if (this.details && this.details.length) {
            this.exitenProductosSeleccionados = true;
        }
    }

    calcularTotalesFactura() {
        let price = 0;
        if (this.details && this.details.length) {
            let hayErrorTipoImpuesto = false;
            let errores = '';
            this.details.forEach(detail => {
                let subtotal = (detail.amount * detail.price) -  detail.discount;
                hayErrorTipoImpuesto = detail.product.taxType != this.appConfig.app.iva.id;
                if (hayErrorTipoImpuesto){
                    errores = errores + (errores == '' ? '' : ', ') + detail.productName;
                }
                if ( detail.product.taxType == this.appConfig.app.iva.id && detail.product.taxFactor == this.appConfig.app.iva.factor ) {
                    this.factura.subTotalIva12 = this.factura.subTotalIva12 + precisionRound(subtotal, 2);
                    this.factura.iva12Total = this.factura.iva12Total + precisionRound(subtotal * (detail.product.taxFactor / 100), 2);
                    detail.taxFactor = detail.product.taxFactor; //REEMPLAZA EL FACTOR DE IMPUESTO
                    detail.taxType = detail.product.taxType; //REEMPLAZA EL TIPO DE IMPUESTO
                } else if (detail.product.taxType == this.appConfig.app.iva.id && detail.product.taxFactor == 0.0) {
                    this.factura.subTotalIva0 = this.factura.subTotalIva0 + precisionRound(subtotal, 2);
                    detail.taxFactor = detail.product.taxFactor; //REEMPLAZA EL FACTOR DE IMPUESTO
                    detail.taxType = detail.product.taxType; //REEMPLAZA EL TIPO DE IMPUESTO
                }
                price = price + subtotal;
            });
            this.factura.price = price;
            this.factura.subTotal = this.factura.subTotalIva12 + this.factura.subTotalIva0;
            this.factura.importeTotal = precisionRound(this.factura.subTotal + this.factura.iva12Total, 2);
            
            if (hayErrorTipoImpuesto){
                this.ui.mostrarMensaje("error", `La configuración del tipo de impuesto de los productos: ${errores}, no es valida. Corrija e intente nuevamente.`);
            }
        } else {
            this.factura.price = 0;
        }
    }

    async activePopupSubjectCustomers(event) {
        this.mostrarPopupSubjectCustomers = true;
    }

    
    handleChangeEsExtranjero($event){
        if (!this.subjectCode) return;
        this.searchSubjectPorCode(event);
    }

    async searchSubjectPorCode(event) {
        this.ui.limpiarMessages();
        this.subjectCodeValid = false;
        let code: string = this.subjectCode ? this.subjectCode.toString() : "";

        if (!code || code.length == 0) {
            return;
        }

        let isRUC: boolean = false;
        let isCI: boolean = false;
        let isPASSPORT: boolean = false;
        const esExtranjero = this.subject.esExtranjero;

        if (esExtranjero){
            isPASSPORT = true;
            this.subjectCodeValid = true;
        } else {
            if (code && code.length == 10) {
                isCI = validateDni(code);
            } else if (code && code.length == 13) {
                isRUC = validateRUC(code);
            }
        }

        if (isCI || isRUC || isPASSPORT) {

            this.subjectCodeValid = true;

            let msg = "Verificando " + (isCI ? 'CI' : isRUC ? 'RUC' : '') + " Nº. " + code;
            this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
            this.verificando = true;

            //Buscar si existe un usuario con ese code
            let data = await this.contactosService.getContactoPorCodeYUsuarioConectadoData(code);
            if (data && data['uuid']) {
                this.subject = data;
                this.subject.usuarioOwner = true;
                this.subject.usuarioAPP = false;
                this.subject.esExtranjero = esExtranjero;
                if (!this.subject.esPersonaNatural && this.subject.code.length == 10 && code.length == 10){
                    this.subject.esPersonaNatural = true;
                } else if (!this.subject.esPersonaNatural && this.subject.code.length == 13 && code.length == 10){
                    this.subject.esPersonaNatural = true; //forzar a persona natural por que esta buscando por cedula
                } else if (!this.subject.esPersonaNatural && this.subject.code.length == 13 && code.length == 13){
                    this.subject.esPersonaNatural = false; //forzar a persona natural por que esta buscando por cedula
                }
                this.ui.mostrarMensaje("info", `¡Está casi listo tu contacto ${this.subject.initials} para ${this.appConfig.app.name}!.`);
                this.verificando = false;
            } else {
                this.subject = new Subject();
                this.subject.code = this.subjectCode;
                this.subject.esExtranjero = esExtranjero;
                this.subject.esPersonaNatural = true;
                this.verificando = false;
            }
        } else {
            this.subject = new Subject();
            this.subject.esExtranjero = esExtranjero;
            this.verificando = false;
            this.ui.mostrarMensaje("error", `${this.appConfig.validationMsgs.cirucCustomerInvalid}`);
        }
    }


    async searchEmailByCode(event) {
        //Validar sólo si es un correo del usuario
        this.emailValid = false;

        this.ui.limpiarMessages();
        if (this.subject.noTieneCorreoElectronico == true) {
            this.emailValid = true;
            return;
        }
        let code: string = this.subject.email ? this.subject.email : "";

        if (!code || code.length == 0) {
            return;
        }

        let msg = "Verificando email " + code;
        this.verificandoData = this.ui.buildResultFromVerify(msg, this.appConfig.ux.messagesType.success);
        this.verificando = true;

        if (code) {
            let emailExistente = false;

            this.emailValid = validateEmail(code);

            if (this.emailValid) {
                emailExistente = await this.administracionService.getEmailPorCodeData(code);
                this.verificando = false;
            } 

            if (emailExistente) {
                this.ui.mostrarMensaje("warn", `El correo electrónico ya se encuentra registrado. Si desea utilizar este correo, marque la casilla [¿Usa un correo electrónico de un familiar u otra persona?]`);
                this.emailValid = false; //No puede continuar con registro
            }
        } else {
            this.verificando = false;
        }
    }

    cargarDataSubjectCustomer(event, item: SubjectCustomer, facturarSoloCedula:boolean) {
        
        this.ui.limpiarMessages();
        this.destinatarios = [];
        if (item) {
            this.subjectCustomer = item;
            if (facturarSoloCedula && item.esPersonaNatural){ //Sobreescribe el código y tipo que llega al backend
                this.subjectCustomer.customerCode=item.nui;
                this.subjectCustomer.customerCodeType='CEDULA';
            }
            this.factura.direccion = this.subjectCustomer.customerDireccion;
            this.destinatarios.push(this.subjectCustomer.customerEmail);
            
            this.filteredDestinatarios();
            
            //Prellenar los campos adicionales que corresponda
            if ( this.camposAdicionales && this.camposAdicionales.length > 0 ) {
                this.camposAdicionales.forEach((item) => {
                    if (this.ui.toLowerCase(item['label']) === "correo"){
                        item['value'] = this.subjectCustomer.customerEmail;
                    } else if (this.ui.toLowerCase(item['label']) === "paciente"){
                        item['value'] = this.subjectCustomer.customerFullName;
                    } else if (this.ui.toLowerCase(item['label']) === "calificación artesanal nro"){
                        item['value'] = this.currentUser.organization.artesanoCalificadoNumero;
                    }
                });
            }
            
            this.mostrarPopupSubjectCustomers = false;
        }
    }

    async activePopupProducts(event) {

        if (!this.seRealizoBusquedaEspecifica){
            //Cargar servicios/productos
            this.busquedaInicial();
        }
        this.mostrarPopupProducts = true;
    }

    async filteredProductByKeyword(event) {
        
        this.processFilter = true;
        this.pageOptions = { page: 0, pageSize: 999, filter: event.target.value, orderBy: 'name', order:'ASC' };
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        const products = this.ui.updateProductsByDetails(this.details, data['content']);
        this.productsFiltered = [...products];
        this.processFilter = false;
        this.seRealizoBusquedaEspecifica = true;
    }
    
    async busquedaInicial() {
        
        this.processFilter = true;
        this.pageOptions = { page: 0, pageSize: 999, filter: '', orderBy: 'name', order:'ASC' };
        const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
        const products = this.ui.updateProductsByDetails(this.details, data['content']);
        this.productsFiltered = [...products];
        this.processFilter = false;
    }

    cargarDataProduct(event, item: Product) {
        this.ui.limpiarMessages();
        if (item) {
            this.productSelected = item;
            if (!item.amount || item.amount == 0) {
                this.productSelected.amount = 1;
            }
            this.agregarProductoSeleccionadoDeProductos();
            this.mostrarPopupProducts = false;
        }
    }

    agregarProductoSeleccionadoDeProductos() {
        this.agregarProductoSeleccionado(this.productSelected);
        this.products = this.ui.updateProductsByDetails(this.details, this.products);
        this.isUnitDetail = this.ui.checkInvoiceSimpleComplex(this.details);
        this.generarFacturaSimpleComplex();
        this.productSelected = new Product();
    }
    
    actualizarDetalle(){
        this.generarFacturaSimpleComplex();
    }

    quitarProductoSeleccionadoDeProductos(event, item: Product) {
        this.productSelected = item;
        this.productSelected.amount = 0;
        this.agregarProductoSeleccionadoDeProductos();
    }

    calcularConSubtotalPersonalizado(event) {
        if (this.product && this.product.id) {//Buscar producto al cual se ha cambiado el precio para cambiar su precio
            let detail: InvoiceDetail = new InvoiceDetail();
            detail.product = this.product;
            detail.price = Number(this.factura.price);
            detail.discount = Number(this.factura.descuento);
            detail.amount = 1;
            this.ui.addDetailToInvoice(this.details, detail, false);
        }
        
        this.resetSumadores();
        this.calcularTotalesFactura();
        
    }

    ejecutarAccionResult(event, accion: string, item: any) {
        this.ui.limpiarMessages();
        if (accion == this.appConfig.ux.actionsExecute.close) {
            this.mostrarResultData = false;
        } else if (accion == 'nueva') {
            this.mostrarResultData = false;
            this.fazilService.irAFactura();
        } else if (accion == 'listado') {
            this.mostrarResultData = false;
            this.fazilService.irAInicio();
        } else {
            this.ui.ejecutarAccionResultFromData(event, accion);//Acciones generales
        }
    }

    camposAdicionalesValidos(): boolean {
        
        
        if (this.factura.internalStatus == 'CREATED' || this.factura.internalStatus == 'POSTED') {
            return true;
        }

        let isValid: boolean = true;
        if (!this.camposAdicionales || (this.camposAdicionales && this.camposAdicionales.length == 0)) {
            isValid = true;
        } else {
            this.camposAdicionales.forEach((item) => {
                if (!item['value'] || item['value'] == undefined || item['value'] == null) {
                    isValid = false;
                } else {
                    if (item['campo'] === "Correo"){
                        isValid = validateEmail(item['value']);
                    }
                }
            });
        }

        return isValid;
    }

    filteredDestinatarios() {
        this.filtered = this.destinatarioCtrl.valueChanges.pipe(
            startWith(null),
            map((destinatario: string | null) => (destinatario ? this._filterDestinatario(destinatario) : this.destinatariosAll.slice())),
        );
    }

    private _filterDestinatario(value: string): string[] {
        const filterValue = value.toLowerCase();
        //return this.destinatariosAll.filter(val => val.toLowerCase().includes(filterValue));
        return this.destinatariosAll.filter(val => val.toLowerCase().indexOf(filterValue) === 0);
    }

    agregarDestinatario(event: MatChipInputEvent): void {

        const input = event.input;
        const value = (event.value || '').trim();

        // Añadir nuestro destinatario
        if (value) {
            const isOptionSelected = this.matAutocomplete.options.some(option => option.selected);
            if (!isOptionSelected && validateEmail(value.trim())) {//Validar si es email
                this.destinatarios.push(value.trim());
            }
        }

        // Limpiar el input
        if (input) {
            input.value = '';
        }

        this.destinatarioCtrl.setValue(null);
    }

    agregarDestinatarioBlur(event: FocusEvent): void {
        const target: HTMLElement = event.relatedTarget as HTMLElement;
        if (!target || target.tagName !== 'MAT-OPTION') {
            const matChipEvent: MatChipInputEvent = { input: this.destinatarioInput.nativeElement, value: this.destinatarioInput.nativeElement.value };
            this.agregarDestinatario(matChipEvent);
        }
    }

    removerDestinatario(value: string): void {
        const index = this.destinatarios.indexOf(value);
        if (index >= 0) {
            this.destinatarios.splice(index, 1);
        }
    }

    selectedDestinatario(event: MatAutocompleteSelectedEvent): void {
        event.option.deselect();
        this.destinatarios.push(event.option.viewValue);
        this.destinatarioInput.nativeElement.value = '';
        this.destinatarioCtrl.setValue(null);
    }

    editarServicio(event, item: Product) {
        this.resetVariablesProducts();
        this.product = item;
        this.productType = this.product.productType;
        this.mostrarEditorProduct = true;
    }
  
    onEditComplete(event): void {
        this.actualizarDetalle();
    }
    
    handleChangeEsCedulaDiferenteAlRUC(event) {
        this.subject.nui = '';
    }

    handleChangeEsPersonalNatural(event) {
        const checked = event.checked;
        if (checked){
            this.subject.subjectType = 'NATURAL';
        } else {
            this.subject.subjectType = 'JURIDICA';
        }
    }
    
    handleProductoGuardado(productoOutput:ProductoOutput){
        
        if (productoOutput.success){

            this.cargarDataProduct(null, productoOutput.data);
            this.mostrarPopupProducts = false;
            this.mostrarEditorProduct = false;
        }   
    }
    
    /**
    * Manejo del evento del componente buscador de contactos, 
    * bien sea por selección o por creación de contacto
    */
    handleProductoSeleccionado(productoOutput:ProductoOutput){
        this.mostrarPopupProducts = false;
        if (productoOutput.success){
            this.cargarDataProduct(null, productoOutput.data);
        }   
    }
    /**
    * Manejo del evento del componente buscador de productos, 
    * bien sea por deselección de producto
    */
    handleProductoDeseleccionado(productoOutput:ProductoOutput){
        this.mostrarPopupProducts = false;
        if (productoOutput.success){
            this.quitarProductoSeleccionadoDeProductos(null, productoOutput.data);
        }   
    }
    /**
    * Manejo del evento del componente buscador de contactos, 
    * bien sea por selección o por creación de contacto
    */
    handleContactoSeleccionado(subjectCustomerOutput:SubjectCustomerOutput){
        this.mostrarPopupSubjectCustomers = false;
        if (subjectCustomerOutput.success){
            const esCedula:boolean = (subjectCustomerOutput.mode == "cedula");
            this.cargarDataSubjectCustomer(null, subjectCustomerOutput.data, esCedula);
        }   
    }
    
    asignarPuntoEmision(pem:EmissionPoint){
        this.emissionPointSelected = pem;
    }
    
}
